import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { FirstTaskRewardApi } from './first-task-reward-api';
import { FirstTaskRewardApiImpl } from './apis/impls/first-task-reward-api';
import { FirstTaskRewardPresenter } from './first-task-reward-presenter';
import { FirstTaskRewardPresenterImpl } from './impls/first-task-reward-presenter';
import { FirstTaskRewardService } from './first-task-reward-service';
import { FirstTaskRewardServiceImpl } from './impls/first-task-reward-service';

/** 注册首次任务奖励的领取、状态与 UI 服务。 */
export const firstTaskRewardModule = (bind: interfaces.Bind) => {
    bind(FirstTaskRewardApi).to(FirstTaskRewardApiImpl);
    bind(FirstTaskRewardPresenter).to(FirstTaskRewardPresenterImpl);
    bind(FirstTaskRewardService).to(FirstTaskRewardServiceImpl).inSingletonScope();
};

export * from './first-task-reward-api';
export * from './first-task-reward-presenter';
export * from './first-task-reward-service';
export { FirstTaskRewardApiImpl } from './apis/impls/first-task-reward-api';
export { FirstTaskRewardPresenterImpl } from './impls/first-task-reward-presenter';
export { FirstTaskRewardServiceImpl } from './impls/first-task-reward-service';
